"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.99993 4.99983V18.3331M9.99993 4.99983H7.05351C6.61938 4.99983 6.20303 4.82423 5.89605 4.51167C5.58907 4.19911 5.41661 3.77519 5.41661 3.33316C5.41661 2.89114 5.58907 2.46722 5.89605 2.15466C6.20303 1.8421 6.61938 1.6665 7.05351 1.6665C9.34517 1.6665 9.99993 4.99983 9.99993 4.99983ZM9.99993 4.99983H12.9463C13.3805 4.99983 13.7968 4.82423 14.1038 4.51167C14.4108 4.19911 14.5832 3.77519 14.5832 3.33316C14.5832 2.89114 14.4108 2.46722 14.1038 2.15466C13.7968 1.8421 13.3805 1.6665 12.9463 1.6665C10.6547 1.6665 9.99993 4.99983 9.99993 4.99983ZM16.6666 9.16648V15.6665C16.6666 16.5999 16.6666 17.0666 16.4849 17.4231C16.3251 17.7367 16.0702 17.9917 15.7566 18.1515C15.4 18.3331 14.9333 18.3331 13.9999 18.3331L5.99994 18.3331C5.06653 18.3331 4.59982 18.3331 4.2433 18.1515C3.9297 17.9917 3.67473 17.7367 3.51494 17.4231C3.33329 17.0666 3.33329 16.5999 3.33329 15.6665V9.16648M1.66663 6.33315L1.66663 7.83315C1.66663 8.29986 1.66663 8.53321 1.75745 8.71147C1.83735 8.86827 1.96483 8.99575 2.12163 9.07565C2.29989 9.16648 2.53325 9.16648 2.99996 9.16648L16.9999 9.16648C17.4666 9.16648 17.7 9.16648 17.8782 9.07565C18.035 8.99576 18.1625 8.86827 18.2424 8.71147C18.3332 8.53321 18.3332 8.29986 18.3332 7.83315V6.33315C18.3332 5.86645 18.3332 5.63309 18.2424 5.45483C18.1625 5.29803 18.035 5.17055 17.8782 5.09065C17.7 4.99983 17.4666 4.99983 16.9999 4.99983L2.99995 4.99983C2.53325 4.99983 2.29989 4.99983 2.12163 5.09065C1.96483 5.17055 1.83735 5.29803 1.75745 5.45483C1.66663 5.63309 1.66663 5.86644 1.66663 6.33315Z",
    stroke: fill,
    strokeWidth: "1.66666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;